import { Component } from "react";
import PropTypes from "prop-types";
import loadSignal from "./loadSignal";

class SignalScriptLoader extends Component {
  static propTypes = {
    isSignalEnabledInBrowseSite: PropTypes.bool
  };

  componentDidUpdate() {
    loadSignal(window.location.href);
  }

  render() {
    return null;
  }
}

export default SignalScriptLoader;
